import { axiosInstance } from '../../helpers/api_helper';

const updateAdmin = async (formData: any) => {
  try {
    console.log('FormData in updateAdmin:', formData);

    const response = await axiosInstance.patch(`/Admin/UpdateProfile`, formData);

    console.log('API Response from updateAdmin:', response); // Log the response

    if (response.data.status === '00') {
      // Handle success, if needed
      return response.data;
    } else {
      // Handle error
      throw new Error('Error updating admin');
    }
  } catch (error:any) {
    // Handle network or other errors
    throw new Error(`Error: ${error.message}`);
  }
};

export { updateAdmin };
